import Socket from "./Socket"
import { net } from "@platform/index"
import { getBrowserFinger } from "./browserFinger"
import { userEnvMap } from "./util"
import { globalInfo } from "../env/util"
import { AES, enc } from "crypto-js"
// import { _decrypt } from "./decrypt"
export const _socket = new Socket()

async function obtainInfo(params: {
  host: string
  appId: string
  tenant: string
}) {
  try {
    const timestamp = new Date().valueOf() // MAX-TIMESTAMP 当前时间戳
    const nonce = Math.floor(Math.random() * 1000000).toString() // MAX-NONCE 6位随机数

    const { host, appId, tenant } = params
    let finger = localStorage.getItem("__finger__" + appId) || null
    if (!finger) {
      sessionStorage.removeItem("message___" + appId)
      finger = await getBrowserFinger()
      localStorage.setItem("__finger__" + appId, finger)
    }
    const body = {
      request: {
        clientType: 3,
        env: userEnvMap[config?.env] || "sandbox",
        finger: finger,
        tenant: tenant,
        appId: appId,
      },
      context: {},
    }
    const url =
      host +
      (host.lastIndexOf("/") === host.length - 1 ? "" : "/") +
      "client/auth/obtainInfo"
    return await net.post(url, {
      headers: {
        "MAX-TIMESTAMP": timestamp,
        // "MAX-SIGN": maxSign,
        "MAX-NONCE": nonce,
        "MAX-SIGN-TYPE": 1,
        "MAX-APP-ID": appId,
      },
      data: body,
    })
  } catch (e) {
    console.error("obtainInfo error", e)
  }
}
// // 在标签页打开时，增加计数器
// if (localStorage.getItem("_browserTabCount_")) {
//   localStorage.setItem(
//     "_browserTabCount_",
//     String(Number(localStorage.getItem("_browserTabCount_")) + 1)
//   )
// } else {
//   localStorage.setItem("_browserTabCount_", "1")
// }
// // 在标签页关闭时，减少计数器
// window.addEventListener("beforeunload", function () {
//   let tabCount = Number(localStorage.getItem("_browserTabCount_")) - 1
//   localStorage.setItem("_browserTabCount_", tabCount.toString())
//   // 如果所有标签页都已关闭，清除localStorage
//   if (tabCount <= 0) {
//     localStorage.removeItem("__finger__")
//     localStorage.removeItem("_browserTabCount_")
//   }
// })

let config: any
export const message = {
  success: {},
  fail: {},
  init(conf: any) {
    config = conf
  },
  async message(topic, successCb, errorCb) {
    try {
      if (!topic) {
        console.error("message must be have topic")
        return
      }
      const appId = config.appId // MAX-APP-ID 应用APPID
      const tenant = config.tenantCode
      const host = globalInfo.get("regionServerSupported") || null
      if (!host) {
        console.error("could not found host", host)
        return
      }
      const _localData = sessionStorage.getItem("message___" + appId) || null
      let topics
      if (_localData && typeof _localData === "string") {
        topics = AES.decrypt(_localData, appId)?.toString(enc?.Utf8) || null
        topics = topics ? JSON.parse(topics) : null
      }
      if (!topics) {
        const { body: { success = false, data = null, msg = "" } = {} } =
          (await obtainInfo({
            host,
            appId,
            tenant,
          })) || {}
        if (!success || !data) {
          console.error("init message error: ", msg)
          sessionStorage.removeItem("message___" + appId)
          return {
            isSuccess: false,
            message: "init message error: " + msg,
          }
        }
        topics = data
        const _data = JSON.stringify(data)
        sessionStorage.setItem(
          "message___" + appId,
          AES.encrypt(_data, appId).toString()
        )
      }
      _socket.subscribe({
        info: { ...topics, appId },
        topic,
        success: successCb,
        fail: errorCb,
        key: this.key,
      })
    } catch (e) {
      console.error("message error: ", e)
    }
  },
} as { message: MessageDSL; init: (config: any) => void }
